import { createAction, props } from '@ngrx/store';
import { NavigationBehaviorOptions, NavigationExtras, UrlTree } from '@angular/router';

export interface RouteData {
  path: any[];
  query?: object;
  extras?: NavigationExtras;
};

export interface UrlNavigationData {
  url: string | UrlTree;
  extras?: NavigationBehaviorOptions
}

export const GO = '[Router] Go';
export const NAVIGATE_TO_URL = '[Router] Navigate to Url'
export const BACK = '[Router] Back';
export const FORWARD = '[Router] Forward';

export const go = createAction(GO, props<{ routeData: RouteData, extendOnly?: boolean }>());
export const navigateToUrl = createAction(NAVIGATE_TO_URL, props<{ urlNavigationData: UrlNavigationData }>());
export const back = createAction(BACK);
export const forward = createAction(FORWARD);